"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _checkbox = _interopRequireDefault(require("./checkbox"));
exports["default"] = _checkbox["default"];